import {Component} from '@angular/core';

@Component({
  selector: 'app-step-one-left-panel',
  templateUrl: './step-one-left-panel.component.html',
  styleUrls: ['./step-one-left-panel.component.css']
})
export class StepOneLeftPanelComponent {

}
